import * as React from 'react';
import { sortBasedOnList } from '../utils';

export type Table12aData = { [key: string]: ITable12aRow };

export interface ITable12aProps {
  data: Table12aData;
}

interface ITable12aState {
}

interface ITable12aRow {
  driversTotal: number;
  driversFatal: number;
  driversInjuryA: number;
  driversInjuryB: number;
  driversInjuryC: number;
  pedestriansTotal: number;
  pedestriansFatal: number;
  pedestriansInjuryA: number;
  pedestriansInjuryB: number;
  pedestriansInjuryC: number;
}

const sortOrder = [
  "Drinking, No test results",
  "BAC < .04",
  "BAC .04 to < .08",
  "BAC .08 to < .10",
  "BAC .10 to < .15",
  "BAC .15 to < .20",
  "BAC .20 or >",
  "TOTAL ALCOHOL INVOLVEMENT"
];

export default class Table12a extends React.Component<ITable12aProps, ITable12aState> {
  constructor(props: ITable12aProps) {
    super(props);
  }

  public render() {
    return (
      this.props.data ?
        <>
          <table className="ss-table summaryTable1">
            <colgroup>
              <col style={{ width: 21 }} />
              <col style={{ width: 579 }} />
            </colgroup>
            <thead>
              <tr>
                <th rowSpan={3} colSpan={2} className="border-right-bold">
                  <div className="ss-table-header">
                    <span className="header-number">12a</span>
                    <span className="header-text">DRIVER AND PEDESTRIAN CONDITION</span>
                  </div>
                </th>
                <th colSpan={5} className="border-right-bold">DRIVERS IN CRASHES</th>
                <th colSpan={5}>PEDESTRIANS IN CRASHES</th>
              </tr>
              <tr>
                <th rowSpan={2}>TOTAL</th>
                <th rowSpan={2}>FATAL</th>
                <th colSpan={3} className="border-right-bold">INJURY</th>
                <th rowSpan={2}>TOTAL</th>
                <th rowSpan={2}>FATAL</th>
                <th colSpan={3}>INJURY</th>
              </tr>
              <tr>
                <th>A*</th>
                <th>B*</th>
                <th className="border-right-bold">C*</th>
                <th>A*</th>
                <th>B*</th>
                <th>C*</th>
              </tr>
            </thead>
            <tbody>
              {sortBasedOnList(this.props.data, sortOrder).map((key, index) => {
                const row = this.props.data[key];
                return (
                  <tr key={key} className={key === "TOTAL ALCOHOL INVOLVEMENT" ? "border-bold bold-text" : null}>
                    {index === 0 &&
                      <td rowSpan={8}>
                        <p style={{
                          textAlign: 'center',
                          width: '5px',
                          transform: 'rotate(270deg)',
                          position: 'relative',
                          top: '24px',
                          left: '8px',
                          margin: 0
                        }}>Alcohol</p>
                      </td>
                    }
                    <td className="border-right-bold">{key}</td>
                    <td className="numberTotals">{row.driversTotal}</td>
                    <td className="numberTotals">{row.driversFatal}</td>
                    <td className="numberTotals">{row.driversInjuryA}</td>
                    <td className="numberTotals">{row.driversInjuryB}</td>
                    <td className="numberTotals border-right-bold">{row.driversInjuryC}</td>
                    <td className="numberTotals">{row.pedestriansTotal}</td>
                    <td className="numberTotals">{row.pedestriansFatal}</td>
                    <td className="numberTotals">{row.pedestriansInjuryA}</td>
                    <td className="numberTotals">{row.pedestriansInjuryB}</td>
                    <td className="numberTotals">{row.pedestriansInjuryC}</td>
                  </tr>)
              })}
            </tbody>
          </table>
          <p className="notes">Blood alcohol content for fatal crashes represent FARS (Fatal Accident Reporting System) statistics and is more complete than initial indications from investigator report.</p>
        </>
        : <p>Loading...</p>
    );
  }
}
